import React from 'react';
import {
  Typography,
  Stack,
} from '@mui/material';
import OperationsIcon from './OperationsIcon';

interface PageTitleProps {
  title: string;
}

const PageTitle: React.FC<PageTitleProps> = ({
  title
}) => {
  return (
    <Stack direction="row" spacing={2} sx={{
      alignItems: "center"
    }}>
      <OperationsIcon />
      <Typography variant="xxl">
        {title}
      </Typography>
    </Stack>
  );
};

export default PageTitle;